import type { ReactNode } from "react"

import { Button } from "../componentes/Button"
import * as Icones from "../componentes/Icones"
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../componentes/Sheet"
import { BOTAO_CANCELAR, CABECALHO_DO_SHEET } from "../lib/classes"

export function GavetaDaFicha({
  aberta,
  titulo,
  aoFechar,
  children,
}: {
  aberta: boolean
  titulo: string
  aoFechar: () => void
  children: ReactNode
}) {
  return (
    <Sheet open={aberta} onOpenChange={(abrir) => !abrir && aoFechar()}>
      <SheetContent
        aria-describedby={undefined}
        className="w-full gap-0 overflow-y-auto bg-card p-0 sm:max-w-lg [&>button:last-child]:text-primary-foreground [&>button:last-child]:opacity-100"
      >
        <SheetHeader className={CABECALHO_DO_SHEET}>
          <SheetTitle className="text-primary-foreground">{titulo}</SheetTitle>
        </SheetHeader>
        <div data-slot="corpo-da-gaveta" className="flex flex-col gap-4 p-6">
          {children}
        </div>
      </SheetContent>
    </Sheet>
  )
}

export function RodapeDaGaveta({
  aoCancelar,
  ocupado = false,
  children,
}: {
  aoCancelar: () => void
  ocupado?: boolean
  children: ReactNode
}) {
  return (
    <div data-slot="rodape-da-gaveta" className="mt-1 flex flex-wrap justify-end gap-2 border-t pt-4">
      <Button type="button" variant="outline" className={BOTAO_CANCELAR} disabled={ocupado} onClick={aoCancelar}>
        <Icones.Fechar />
        Cancelar
      </Button>
      {children}
    </div>
  )
}
